(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-ajax"] && !Shopify.designMode) return;
  try {
    window.Surfskjulet = window.Surfskjulet || {};

  window.Surfskjulet.cartChangeLine = async function (options) {
    const response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        line: options.line,
        quantity: options.quantity,
        sections: options.sections,
        sections_url: options.sectionsUrl || window.location.pathname,
      }),
    });
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || 'cart update failed');
    return data;
  };

  window.Surfskjulet.cartParseSection = function (html, tagName) {
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    return parsed.querySelector(tagName);
  };
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["delivery-choice"] && !Shopify.designMode) return;
  try {
    // Progressiv förbättring: spegla valt/disabled till <label> så stylingen
  // fungerar även utan :has()-stöd. Native radio sköter tangentbord + state.
  (function () {
    document.querySelectorAll('[data-delivery-choice]').forEach(function (group) {
      var options = group.querySelectorAll('.delivery-choice__option');

      function sync() {
        options.forEach(function (option) {
          var input = option.querySelector('.delivery-choice__input');
          if (!input) return;
          option.classList.toggle('is-selected', input.checked);
          option.classList.toggle('is-disabled', input.disabled);
        });
      }

      group.addEventListener('change', sync);
      sync();
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["guide-cta"] && !Shopify.designMode) return;
  try {
    if (!window.__guideCtaTrackingBound) {
  window.__guideCtaTrackingBound = true;
  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-guide-link]');
    if (!link) return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'guide_link_click',
      guide_link_placement: link.dataset.guideLinkPlacement || 'unknown'
    });
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-gallery"] && !Shopify.designMode) return;
  try {
    class ProductGallery extends HTMLElement {
    connectedCallback() {
      this.mainImage = this.querySelector('[data-main-image]');
      this.thumbs = Array.from(this.querySelectorAll('[data-thumb]'));
      this.prevBtn = this.querySelector('[data-nav-prev]');
      this.nextBtn = this.querySelector('[data-nav-next]');

      this.thumbs.forEach((thumb, index) => {
        thumb.addEventListener('click', () => this.selectThumb(thumb));
        thumb.addEventListener('keydown', (event) => {
          if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
          event.preventDefault();
          const nextIndex = event.key === 'ArrowRight'
            ? (index + 1) % this.thumbs.length
            : (index - 1 + this.thumbs.length) % this.thumbs.length;
          const next = this.thumbs[nextIndex];
          next.focus();
          this.selectThumb(next);
        });
      });

      this.prevBtn?.addEventListener('click', () => this.step(-1));
      this.nextBtn?.addEventListener('click', () => this.step(1));
    }

    step(direction) {
      if (!this.thumbs.length) return;
      const currentIndex = this.thumbs.findIndex((t) => t.classList.contains('is-active'));
      const fromIndex = currentIndex === -1 ? 0 : currentIndex;
      const nextIndex = (fromIndex + direction + this.thumbs.length) % this.thumbs.length;
      this.selectThumb(this.thumbs[nextIndex]);
    }

    selectThumb(thumb) {
      if (!this.mainImage || !thumb) return;
      this.mainImage.src = thumb.dataset.fullSrc;
      if (thumb.dataset.fullSrcset) {
        this.mainImage.srcset = thumb.dataset.fullSrcset;
        this.mainImage.sizes = '(min-width: 990px) min(50vw, 800px), 100vw';
      } else {
        this.mainImage.removeAttribute('srcset');
      }
      this.thumbs.forEach((t) => {
        const isActive = t === thumb;
        t.classList.toggle('is-active', isActive);
        t.setAttribute('aria-selected', String(isActive));
      });
    }

    selectByMediaId(mediaId, fullSrc) {
      if (!this.mainImage) return;
      const match = this.thumbs.find((t) => t.dataset.mediaId === String(mediaId));
      if (match) {
        this.selectThumb(match);
        return;
      }
      this.mainImage.removeAttribute('srcset');
      this.mainImage.src = fullSrc;
      this.thumbs.forEach((t) => {
        t.classList.remove('is-active');
        t.setAttribute('aria-selected', 'false');
      });
    }
  }

  window.Surfskjulet = window.Surfskjulet || {};
  window.Surfskjulet.ProductGallery = ProductGallery;
  if (!customElements.get('product-gallery')) customElements.define('product-gallery', ProductGallery);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-reviews"] && !Shopify.designMode) return;
  try {
    class ProductReviews extends HTMLElement {
    connectedCallback() {
      this.productId = this.dataset.productId;
      this.list = this.querySelector('[data-reviews-list]');
      this.loadMoreWrap = this.querySelector('[data-reviews-load-more]');
      this.loadMoreBtn = this.querySelector('[data-reviews-load-more-btn]');
      this.form = this.querySelector('[data-reviews-form]');
      this.formMessage = this.querySelector('[data-reviews-form-message]');
      this.openBtn = this.querySelector('[data-reviews-open-form]');
      this.cancelBtn = this.querySelector('[data-reviews-cancel]');
      this.submitBtn = this.querySelector('[data-reviews-submit]');
      this.cursor = null;
      this.reviewCount = Number(this.dataset.reviewCount || 0);
      // Ids already rendered server-side from the published_json cache, so a
      // "load more" / fallback fetch never appends a duplicate card.
      this.seenIds = new Set(
        [...this.list.querySelectorAll('[data-review-id]')].map((el) => el.dataset.reviewId)
      );

      this.openBtn?.addEventListener('click', () => {
        this.form.hidden = false;
        this.openBtn.hidden = true;
      });
      this.cancelBtn?.addEventListener('click', () => this.closeForm());
      this.form?.addEventListener('submit', (event) => this.handleSubmit(event));
      this.loadMoreBtn?.addEventListener('click', () => this.loadReviews());

      // The list is server-rendered. Only fetch client-side when the cache
      // was missing (needs-fetch) — "load more" for the truncated overflow
      // is user-triggered via the button wired above.
      if (this.dataset.needsFetch === 'true') {
        this.loadReviews();
      }
    }

    closeForm() {
      this.form.hidden = true;
      if (this.openBtn) this.openBtn.hidden = false;
      this.form.reset();
      this.querySelectorAll('star-input').forEach((el) => el.sync?.());
      this.hideMessage();
    }

    showMessage(text, isError) {
      if (!this.formMessage) return;
      this.formMessage.textContent = text;
      this.formMessage.hidden = false;
      this.formMessage.classList.toggle('product-reviews__form-message--error', Boolean(isError));
    }

    hideMessage() {
      if (this.formMessage) this.formMessage.hidden = true;
    }

    async loadReviews() {
      if (!this.list) return;
      const url = new URL('/apps/reviews/list', window.location.origin);
      url.searchParams.set('productId', this.productId);
      if (this.cursor) url.searchParams.set('cursor', this.cursor);

      try {
        const response = await fetch(url.toString(), { headers: { Accept: 'application/json' } });
        const data = await response.json();
        if (!response.ok) throw new Error('list failed');

        data.reviews.forEach((review) => {
          if (review.id && this.seenIds.has(review.id)) return;
          if (review.id) this.seenIds.add(review.id);
          this.list.appendChild(this.renderReview(review));
        });
        this.cursor = data.pageInfo && data.pageInfo.hasNextPage ? data.pageInfo.endCursor : null;
        if (this.loadMoreWrap) this.loadMoreWrap.hidden = !this.cursor;

        const hasCard = this.list.querySelector('.product-reviews__card');
        const hasEmpty = this.list.querySelector('.product-reviews__empty');
        if (!hasCard && !hasEmpty) {
          const empty = document.createElement('p');
          empty.className = 'product-reviews__empty';
          empty.textContent = this.dataset.emptyText || '';
          this.list.appendChild(empty);
        }
      } catch (error) {
        // Silent — browsing customers just see no review list rather than an error banner.
      }
    }

    renderReview(review) {
      const card = document.createElement('article');
      card.className = 'product-reviews__card';
      if (review.id) card.dataset.reviewId = review.id;

      const header = document.createElement('div');
      header.className = 'product-reviews__card-header';

      const stars = document.createElement('span');
      stars.className = 'star-rating star-rating--sm';
      stars.style.setProperty('--rating', review.rating);
      stars.setAttribute('role', 'img');
      stars.setAttribute('aria-label', `${review.rating} ${this.dataset.starLabel || ''}`);
      const track = document.createElement('span');
      track.className = 'star-rating__track';
      const fill = document.createElement('span');
      fill.className = 'star-rating__fill';
      stars.append(track, fill);
      header.appendChild(stars);

      if (review.verifiedPurchase) {
        const badge = document.createElement('span');
        badge.className = 'product-reviews__badge';
        badge.textContent = this.dataset.verifiedBadge || '';
        header.appendChild(badge);
      }
      card.appendChild(header);

      const title = document.createElement('h3');
      title.className = 'product-reviews__card-title';
      title.textContent = review.title;
      card.appendChild(title);

      const body = document.createElement('p');
      body.className = 'product-reviews__card-body';
      body.textContent = review.body;
      card.appendChild(body);

      const meta = document.createElement('div');
      meta.className = 'product-reviews__card-meta';
      const name = document.createElement('span');
      name.textContent = review.customerName;
      const date = document.createElement('span');
      date.className = 'font-mono';
      date.textContent = new Date(review.createdAt).toLocaleDateString('sv-SE');
      meta.append(name, date);
      card.appendChild(meta);

      return card;
    }

    async handleSubmit(event) {
      event.preventDefault();
      this.hideMessage();

      const formData = new FormData(this.form);
      const rating = Number(formData.get('rating'));
      if (!rating) {
        this.showMessage(this.dataset.errorRatingRequired || '', true);
        return;
      }

      this.submitBtn?.setAttribute('disabled', 'true');
      try {
        const response = await fetch('/apps/reviews/submit', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            productId: `gid://shopify/Product/${this.productId}`,
            rating,
            title: formData.get('title'),
            body: formData.get('body'),
            website: formData.get('website'),
            customerName: this.dataset.customerName || '',
          }),
        });
        const data = await response.json();

        if (!response.ok) {
          const messages = {
            purchase_not_verified: this.dataset.errorNotVerified,
            already_reviewed: this.dataset.errorDuplicate,
            rate_limited: this.dataset.errorRateLimited,
          };
          this.showMessage(messages[data.error] || this.dataset.errorText || '', true);
          return;
        }

        this.form.hidden = true;
        this.showMessage(this.dataset.successText || '', false);
      } catch (error) {
        this.showMessage(this.dataset.errorText || '', true);
      } finally {
        this.submitBtn?.removeAttribute('disabled');
      }
    }
  }

  window.Surfskjulet = window.Surfskjulet || {};
  window.Surfskjulet.ProductReviews = ProductReviews;
  if (!customElements.get('product-reviews')) customElements.define('product-reviews', ProductReviews);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-size-hint"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('size-hint')) return;

    class SizeHint extends HTMLElement {
      connectedCallback() {
        // Elementet kan flyttas i DOM:en (produktsidans högerspalt) – bind bara en gång.
        if (this.dataset.bound === 'true') return;
        this.dataset.bound = 'true';
        this.isEn = this.dataset.en === 'true';
        this.weight = this.querySelector('[data-hint-weight]');
        this.skill = this.querySelector('[data-hint-skill]');
        this.wind = this.querySelector('[data-hint-wind]');
        this.result = this.querySelector('[data-hint-result]');
        this.text = this.querySelector('[data-hint-text]');
        this.pick = this.querySelector('[data-hint-pick]');
        this.tracked = false;

        [this.weight, this.skill, this.wind].forEach((el) => {
          el.addEventListener('input', () => this.schedule());
          el.addEventListener('change', () => this.schedule());
        });
        this.pick.addEventListener('click', () => {
          if (this.pickButton) this.pickButton.click();
        });
      }

      schedule() {
        clearTimeout(this.timer);
        this.timer = setTimeout(() => this.update(), 250);
      }

      async load() {
        if (!this.loading) {
          this.loading = Promise.all([
            import(this.dataset.engineUrl),
            fetch(this.dataset.rulesUrl).then((r) => r.json())
          ]).then(([engine, rules]) => ({ engine, rules }));
        }
        return this.loading;
      }

      sizes() {
        const root = this.closest('product-info') || document;
        return [...root.querySelectorAll('[data-variant-option]')]
          .map((btn) => {
            const label = btn.querySelector('.product-info__variant-liter');
            const n = parseFloat((label ? label.textContent : '').replace(',', '.'));
            return { btn, size: n, title: label ? label.textContent.trim() : '', available: !btn.hasAttribute('data-unavailable') };
          })
          .filter((v) => Number.isFinite(v.size));
      }

      nearest(list, target) {
        let best = null;
        list.forEach((v) => {
          if (!best || Math.abs(v.size - target) < Math.abs(best.size - target)) best = v;
        });
        return best;
      }

      async update() {
        const weight = Number(this.weight.value);
        const wind = Number(this.wind.value);
        if (!(weight >= 20 && weight <= 150) || !(wind >= 1)) {
          this.result.hidden = true;
          return;
        }
        let r;
        try {
          const { engine, rules } = await this.load();
          const input = { weight_kg: weight, wind_ms: wind, skill: this.skill.value, discipline: this.dataset.discipline };
          r = this.dataset.type === 'Bräda' ? engine.calculateBoardVolume(input, rules) : engine.calculateSailSize(input, rules);
        } catch (err) {
          console.error('[size-hint]', err);
          this.result.hidden = true;
          return;
        }
        this.render(r);
        if (!this.tracked) {
          this.tracked = true;
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({ event: 'size_hint_calculated', size_hint_type: this.dataset.type, size_hint_product: this.dataset.product });
        }
      }

      render(r) {
        const unit = this.dataset.type === 'Bräda' ? 'L' : 'm²';
        // Punkt som decimaltecken, samma som i storleksknapparnas titlar ("6.2 m²").
        const fmt = (n) => (Number.isInteger(n) ? String(n) : n.toFixed(1));
        const list = this.sizes();
        const near = this.nearest(list, r.point);
        const nearAvail = this.nearest(list.filter((v) => v.available), r.point);
        const t = this.isEn
          ? { rec: 'We recommend about', range: 'range', closest: 'Closest size', soldOut: 'is sold out', next: 'Closest in stock', pick: 'Choose', note: 'A guideline, not a guarantee.' }
          : { rec: 'Vi rekommenderar ca', range: 'spann', closest: 'Närmaste storlek', soldOut: 'är slutsåld', next: 'Närmaste i lager', pick: 'Välj', note: 'Ett riktvärde, inte en garanti.' };

        let html = `${t.rec} <strong>${fmt(r.point)} ${unit}</strong> (${t.range} ${fmt(r.min)}–${fmt(r.max)} ${unit}).`;
        let target = null;
        if (near) {
          html += ` ${t.closest}: <strong>${near.title}</strong>`;
          if (!near.available) {
            html += ` ${t.soldOut}.`;
            if (nearAvail) html += ` ${t.next}: <strong>${nearAvail.title}</strong>.`;
            target = nearAvail;
          } else {
            html += '.';
            target = near;
          }
        }
        html += ` <span class="size-hint__note">${t.note}</span>`;
        this.text.innerHTML = html;
        this.pickButton = target ? target.btn : null;
        if (target) {
          this.pick.textContent = `${t.pick} ${target.title}`;
          this.pick.hidden = false;
        } else {
          this.pick.hidden = true;
        }
        this.result.hidden = false;
      }
    }

    customElements.define('size-hint', SizeHint);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["star-rating"] && !Shopify.designMode) return;
  try {
    class StarInput extends HTMLElement {
    connectedCallback() {
      this.range = this.querySelector('.star-rating__range');
      if (!this.range) return;
      this.range.addEventListener('input', () => this.sync());
      this.addEventListener('pointerdown', (event) => this.dragTo(event));
      this.addEventListener('pointermove', (event) => {
        if (event.buttons === 1) this.dragTo(event);
      });
      this.sync();
    }

    dragTo(event) {
      const rect = this.getBoundingClientRect();
      const ratio = Math.min(1, Math.max(0, (event.clientX - rect.left) / rect.width));
      const value = Math.round(ratio * 10) / 2;
      if (String(value) !== this.range.value) {
        this.range.value = String(value);
        this.range.dispatchEvent(new Event('input', { bubbles: true }));
      }
      this.range.focus();
    }

    sync() {
      this.style.setProperty('--rating', this.range.value || '0');
    }
  }
  if (!customElements.get('star-input')) customElements.define('star-input', StarInput);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sticky-buy-bar"] && !Shopify.designMode) return;
  try {
    class StickyBuyBar extends HTMLElement {
    connectedCallback() {
      this.form = document.getElementById('ProductForm');
      this.realBtn = this.form && this.form.querySelector('[data-add-to-cart]');
      this.realPrice = document.querySelector('[data-price]');
      this.addBtn = this.querySelector('[data-sticky-add]');
      this.priceEl = this.querySelector('[data-sticky-price]');
      if (!this.form || !this.realBtn || !this.addBtn) return;

      // Enable — CSS keeps it off-screen (translateY) until .is-visible.
      this.hidden = false;

      this.addBtn.addEventListener('click', () => {
        if (this.needsSize()) {
          this.goToSizes();
          return;
        }
        if (this.addBtn.disabled) return;
        // Route through the real button so the existing form submit
        // handler (ProductInfo.handleAddToCart) runs unchanged.
        this.realBtn.click();
      });

      this.sync();
      this.observer = new MutationObserver(() => this.sync());
      this.observer.observe(this.realBtn, {
        attributes: true,
        childList: true,
        subtree: true,
        characterData: true,
        attributeFilter: ['disabled'],
      });
      if (this.realPrice) {
        this.observer.observe(this.realPrice, { childList: true, subtree: true, characterData: true });
      }

      // Show only once the real add-to-cart button has scrolled out of view.
      this.io = new IntersectionObserver(
        ([entry]) => this.classList.toggle('is-visible', !entry.isIntersecting),
        { rootMargin: '0px 0px -12px 0px' }
      );
      this.io.observe(this.realBtn);
    }

    // Inget val gjort än: knappen leder till storleksväljaren i stället för
    // att vara grå och död.
    needsSize() {
      return (
        this.realBtn.disabled &&
        document.querySelector('[data-variant-option]') !== null &&
        document.querySelector('[data-variant-option][aria-pressed="true"]') === null
      );
    }

    goToSizes() {
      const picker = document.querySelector('.product-info__variants');
      if (!picker) return;
      picker.scrollIntoView({ behavior: 'smooth', block: 'center' });
      picker.classList.add('is-highlighted');
      clearTimeout(this.highlightTimer);
      this.highlightTimer = setTimeout(() => picker.classList.remove('is-highlighted'), 1800);
    }

    sync() {
      if (this.priceEl && this.realPrice) {
        this.priceEl.textContent = this.realPrice.textContent.trim();
      }
      this.addBtn.disabled = this.realBtn.disabled && !this.needsSize();
      const label = this.realBtn.querySelector('[data-add-to-cart-text]');
      if (label) this.addBtn.textContent = label.textContent.trim();
    }

    disconnectedCallback() {
      this.observer && this.observer.disconnect();
      this.io && this.io.disconnect();
    }
  }

  window.Surfskjulet = window.Surfskjulet || {};
  window.Surfskjulet.StickyBuyBar = StickyBuyBar;
  if (!customElements.get('sticky-buy-bar')) customElements.define('sticky-buy-bar', StickyBuyBar);
  } catch(e) { console.error(e); }
})();

})();
